module.exports = __webpack_public_path__ + "static/media/ready-to-sell.94c4496c.jpg";